import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClose", "isOpen", "children", "variantProps", "dataTestId", "hasAutoFocus", "headerStyles"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import { useScreenSize } from '@whitbread-eos/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CookieModal(_ref) {
  var onClose = _ref.onClose,
    isOpen = _ref.isOpen,
    children = _ref.children,
    variantProps = _ref.variantProps,
    dataTestId = _ref.dataTestId,
    _ref$hasAutoFocus = _ref.hasAutoFocus,
    hasAutoFocus = _ref$hasAutoFocus === void 0 ? true : _ref$hasAutoFocus,
    headerStyles = _ref.headerStyles,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var prefix = dataTestId ? "".concat(dataTestId, "-") : '';
  var _useScreenSize = useScreenSize(),
    isLessThanMobile = _useScreenSize.isLessThanMobile;
  var compModalHeaderStyles = headerStyles ? _objectSpread(_objectSpread({}, modalHeaderStyle), headerStyles) : _objectSpread({}, modalHeaderStyle);
  return _jsxs(Modal, _objectSpread(_objectSpread({
    "data-testid": "".concat(prefix, "ChakraModal"),
    preserveScrollBarGap: true,
    scrollBehavior: "inside",
    isOpen: isOpen,
    onClose: onClose
  }, otherProps), {}, {
    autoFocus: hasAutoFocus,
    closeOnEsc: variantProps === null || variantProps === void 0 ? void 0 : variantProps.closeOnOverlayClick,
    closeOnOverlayClick: variantProps === null || variantProps === void 0 ? void 0 : variantProps.closeOnOverlayClick,
    size: isLessThanMobile ? 'full' : 'md',
    children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, _objectSpread(_objectSpread({
      "data-testid": "".concat(prefix, "ModalContent")
    }, modalContentStyle(variantProps === null || variantProps === void 0 ? void 0 : variantProps.isCookieConsentModal)), {}, {
      width: otherProps.size ? 'auto' : {
        mobile: 'full',
        sm: 'auto'
      },
      children: [_jsx(ModalHeader, _objectSpread(_objectSpread({}, compModalHeaderStyles), {}, {
        "data-testid": "".concat(prefix, "ModalHeader"),
        children: variantProps && _jsx(Text, _objectSpread(_objectSpread({}, headerTitleStyle), {}, {
          "data-testid": "".concat(prefix, "ModalTitle"),
          children: variantProps.title
        }))
      })), _jsx(ModalBody, _objectSpread(_objectSpread({
        "data-testid": "".concat(prefix, "ModalBody")
      }, modalBodyStyle), {}, {
        children: children
      }))]
    }))]
  }));
}
var modalContentStyle = isCookieConsentModal => {
  return {
    maxW: 'auto',
    maxH: 'auto',
    overflow: 'auto',
    height: {
      mobile: 'full',
      sm: 'fit-content'
    },
    maxHeight: {
      mobile: 'full',
      sm: 'calc(100% - 6rem)'
    },
    top: {
      mobile: 0,
      sm: '10%',
      lg: isCookieConsentModal && '10%'
    },
    m: '0',
    mt: {
      mobile: '0',
      sm: '2xl'
    },
    mb: {
      mobile: '0',
      sm: '2xl'
    },
    borderRadius: {
      mobile: '0',
      sm: '0.875rem'
    },
    boxShadow: '0 0.125rem 0.75rem var(--chakra-colors-darkGrey2)'
  };
};
var modalHeaderStyle = {
  pb: 0,
  pt: 'lg',
  px: 'lg'
};
var headerTitleStyle = {
  color: 'darkGrey1',
  justifyContent: 'center',
  fontSize: {
    mobile: '2xl',
    md: '3xl'
  },
  lineHeight: '4',
  fontWeight: 'semibold',
  fontFamily: 'header'
};
var modalBodyStyle = {
  p: '0'
};